var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('v-btn',_vm._g({class:_vm.size,attrs:{"block":"","id":_vm.id,"name":_vm.name,"color":_vm.color,"type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }